import React from "react";
import { useState, useEffect } from "react";
import TopHeader from "../../../Components/TopHeader";
import Prince from "../../../Components/Prince";
import { DateRangePicker } from "react-date-range";
import { format } from "date-fns";

import { MdDateRange } from "react-icons/md";

import CardComponent from "../ReportComponent/CardComponent";

import PipelineFilterComponent from "../ReportComponent/PipelineFilterComponent";
import { Link } from "react-router-dom";
import ExportButton from "../../../Components/ExportButton";
//import { isArray } from "jodit/types/core/helpers";

function PipelineReport() {
  const apiUrl = process.env.REACT_APP_URL;
  const Token = localStorage.getItem("_ux98c_v1");
  const [dateFilterModalOPen, setDateFilterModalOpen] = useState(false);
  const [modelOpen, setModalOpen] = useState(false);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [headerCount, setHeaderCount] = useState([]);
  const [shipmentPotentialCount, setShipmentPotentialCount] = useState([]);
  const [wonLostCount, setWonLostCount] = useState([]);
  const [stageCount, setStageCount] = useState([]);
  const [forecastNumberCount, setforecastNumberCount] = useState([]);
  const [leadSourceOptions, setLeadSourceOptions] = useState([]);
  const [employeeId, setEmployeeId] = useState([]);
  const [state, setStates] = useState([]);
  const [leadStatus, setLeadStatus] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [shipmentPotentialOptions, setShipmentPotentialOptions] = useState([]);

  const onFilterChange = (data) => {
    setFilterData(data);
    //console.log(filterData);
  };

  const [date, setDate] = useState(null);
  const handleDateFilterClick = () => {
    setDateFilterModalOpen(true);
  };
  const handleCloseDateFilterModal = () => {
    setDateFilterModalOpen(false);
  };

  const handleDateChange1 = (ranges) => {
    const adjustedStartDate = new Date(ranges.selection.startDate);
    adjustedStartDate.setUTCDate(adjustedStartDate.getUTCDate() + 1); // Subtract one day
    adjustedStartDate.setUTCHours(0, 0, 0, 0); // Set time to 00:00:00 UTC

    const adjustedEndDate = new Date(ranges.selection.endDate);
    adjustedEndDate.setUTCDate(adjustedEndDate.getUTCDate() + 1); // Add one day
    adjustedEndDate.setUTCHours(0, 0, 0, 0); // Set time to 00:00:00 UTC

    setFrom(adjustedStartDate.toISOString()); // Convert to UTC string format
    setTo(adjustedEndDate.toISOString());
    setDate(ranges.selection);

    if (
      ranges.selection.startDate &&
      ranges.selection.endDate &&
      ranges.selection.startDate.getTime() !==
        ranges.selection.endDate.getTime()
    ) {
      handleCloseDateFilterModal(); // close modal
    }
  };

  // console.log(filterData);
  // useEffect(() => {
  const fetchData = async () => {
    try {
      const [response1, response2, response3, response4, response5] =
        await Promise.all([
          fetch(`${apiUrl}/pipeLineReport/headerCount`, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${Token}`,
            },
          }),
          fetch(
            `${apiUrl}/pipeLineReport/shipmentPotentialCount?from=${from}&to=${to}&shipmentPotential=${
              filterData.filterByBusinessCategory || ""
            }&employeeId=${filterData.filterByLeadPipeline || ""}&status=${
              filterData.filterByPartner || ""
            }`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Token}`,
              },
            }
          ),
          fetch(
            `${apiUrl}/pipeLineReport/wonLostCounts?from=${from}&to=${to}&shipmentPotential=${
              filterData.filterByBusinessCategory || ""
            }&employeeId=${filterData.filterByLeadPipeline || ""}&status=${
              filterData.filterByPartner || ""
            }`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Token}`,
              },
            }
          ),
          fetch(
            `${apiUrl}/pipeLineReport/stageCount?from=${from}&to=${to}&shipmentPotential=${
              filterData.filterByBusinessCategory || ""
            }&employeeId=${filterData.filterByLeadPipeline || ""}&status=${
              filterData.filterByPartner || ""
            }`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Token}`,
              },
            }
          ),
          fetch(
            `${apiUrl}/pipeLineReport/forecastnumber?from=${from}&to=${to}&shipmentPotential=${
              filterData.filterByBusinessCategory || ""
            }&employeeId=${filterData.filterByLeadPipeline || ""}&status=${
              filterData.filterByPartner || ""
            }`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Token}`,
              },
            }
          ),
        ]);

      const [data1, data2, data3, data4, data5] = await Promise.all([
        response1.json(),
        response2.json(),
        response3.json(),
        response4.json(),
        response5.json(),
      ]);

      setHeaderCount(data1.data);
      setShipmentPotentialCount(data2.data);
      setWonLostCount(data3.data);
      setStageCount(data4.data);
      setforecastNumberCount(data5.data);
    } catch (error) {
      console.log(`Error in Fetching Data... ${error}`);
    }
  };

  //   fetchData();
  // }, []);
  useEffect(() => {
    fetchData();
  }, []);

  const handleApplyFilter = () => {
    fetchData();
  };

  useEffect(() => {
    // Make an API request to fetch gender options
    fetch(`${apiUrl}/master/getAllMasterData/1`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setLeadSourceOptions(data.data);
        }
      });

    fetch(`${apiUrl}/employee/allStates/101`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setStates(data.data);
        }
      })
      .catch((error) => {
        // console.error("Error fetching gender options:", error);
      });
  }, []);

  useEffect(() => {
    fetch(`${apiUrl}/master/getAllMasterData/4`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setShipmentPotentialOptions(data.data);
        }
      })
      .catch((error) => {});
  }, []);

  useEffect(() => {
    // Make an API request to fetch gender options
    fetch(`${apiUrl}/master/getAllMasterData/8`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setLeadStatus(data.data);
        }
      });
  }, []);

  useEffect(() => {
    fetch(`${apiUrl}/employee/empDropdownSub`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setEmployeeId(data.data);
        }
      })
      .catch((error) => {});
  }, []);

  // console.log(headerCount);
  return (
    <>
      <div className="page">
        <TopHeader />
        <Prince />
        <div className="main-content side-content pt-0 m-0">
          <div className="main-container container-fluid">
            <div className="inner-body">
              <div className="page-header my-2">
                <div>
                  <h2 className="main-content-title tx-24 mb-0 mt-1 ">
                    Pipeline Report
                  </h2>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a>Report</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Pipeline Report
                    </li>
                  </ol>
                </div>
              </div>
              <div style={{ marginTop: "15px" }}>
                <div className="row">
                  <CardComponent
                    title={"Total Leads"}
                    link={"Total Leads"}
                    count={headerCount?.totalLeadCount}
                  />
                  <CardComponent
                    title={"Total Open Leads"}
                    link={"Total Open Leads"}
                    count={headerCount?.openLeadCount}
                  />

                  <CardComponent
                    title={"Shipment Potential"}
                    link={"Shipment Potential"}
                    count={headerCount.totalShipment}
                  />
                  <div className="card custom-card">
                    <div className="card-body py-0 pb-3">
                      <div className="d-flex">
                        <div className="col-sm-2 mt-3">
                          <label>Date Filter</label>
                          <div>
                            <button
                              className="calender btn btn-outline-danger"
                              onClick={handleDateFilterClick}
                              style={{
                                fontSize: "11px",
                                // width: "215px",
                              }}
                            >
                              <MdDateRange
                                size={16}
                                style={{ display: "inline" }}
                              />{" "}
                              {date
                                ? `${format(
                                    date.startDate,
                                    "MMM dd yyyy"
                                  )} -- ${format(date.endDate, "MMM dd yyyy")}`
                                : "Select Calender Date"}
                            </button>
                          </div>
                          <div
                            className={`modal ${
                              dateFilterModalOPen ? "show" : ""
                            } bg-black-7`}
                            style={{
                              display: dateFilterModalOPen ? "block" : "none",
                            }}
                            tabIndex="-1"
                            role="dialog"
                          >
                            <div
                              className=" modal-dialog modal-dialog modal-lg"
                              role="document"
                              style={{ marginTop: "80px" }}
                            >
                              <div
                                className="modal-content"
                                style={{ borderRadius: "8px" }}
                              >
                                <div className="modal-header">
                                  <h5 className="modal-title">
                                    Select Date Range
                                  </h5>
                                  <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={handleCloseDateFilterModal}
                                  >
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                </div>
                                <div
                                  className="modal-body"
                                  style={{ width: "100%" }}
                                >
                                  <DateRangePicker
                                    // ranges={[date]}
                                    ranges={
                                      date
                                        ? [date]
                                        : [
                                            {
                                              startDate: new Date(),
                                              endDate: new Date(),
                                              key: "selection",
                                            },
                                          ]
                                    }
                                    onChange={handleDateChange1}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <PipelineFilterComponent
                          shipmentPotentialOptions={shipmentPotentialOptions}
                          leadStatus={leadStatus}
                          employeeId={employeeId}
                          onFilterChange={onFilterChange}
                        />

                        <div className="d-flex mt-3">
                          <div className="mr-2">
                            <button
                              style={{ marginTop: "30px" }}
                              className="btn btn-outline-success"
                              onClick={handleApplyFilter}
                            >
                              Apply Filter
                            </button>
                          </div>
                          <div className="mx-2">
                            <button
                              style={{ marginTop: "30px" }}
                              className="btn btn-outline-warning"
                              onClick={() => {
                                setDate({
                                  startDate: new Date(),
                                  endDate: new Date(),
                                  key: "selection",
                                });
                                window.location.reload();
                              }}
                            >
                              Clear Filter
                            </button>
                          </div>
                        </div>
                      </div>{" "}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card custom-card">
                      <div className="card-body">
                        <h5 style={{ textDecoration: "underline" }}>
                          Lead Won vs Lost
                        </h5>

                        <div class="table-responsive">
                          <table class="table table-hover table-nowrap">
                            <thead class="table-light">
                              <tr>
                                <th scope="col">Metric</th>
                                <th scope="col">Count</th>
                                <th scope="col">Percentage</th>
                                <th scope="col">Forcasted Sales</th>
                                {/* <th scope="col">Rate</th> */}
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td data-label="Email">
                                  <span>Deals Open</span>
                                </td>
                                <td data-label="Phone">
                                  <Link
                                    class="text-current"
                                    to="/leads/Open"
                                    //href="mailto:robert.fox@example.com"
                                  >
                                    {Array.isArray(wonLostCount) &&
                                      wonLostCount.length &&
                                      wonLostCount[0]?.dealOpen}
                                  </Link>
                                </td>
                                <td data-label="Lead Score">
                                  <a
                                    class="text-current"
                                    // href="tel:202-555-0152"
                                  >
                                    {Array.isArray(wonLostCount) &&
                                      wonLostCount.length &&
                                      wonLostCount[0]?.percentage}
                                  </a>
                                </td>
                                <td data-label="Lead Score">
                                  <a
                                    class="text-current"
                                    // href="tel:202-555-0152"
                                  >
                                    {Array.isArray(wonLostCount) &&
                                      wonLostCount.length &&
                                      wonLostCount[0]?.forecastedSales}
                                  </a>
                                </td>
                              </tr>
                              <tr>
                                <td data-label="Email">
                                  <span>Deals Won</span>
                                </td>
                                <td data-label="Phone">
                                  <Link
                                    class="text-current"
                                    to="/leads/Won"
                                    //href="mailto:robert.fox@example.com"
                                  >
                                    {Array.isArray(wonLostCount) &&
                                      wonLostCount.length &&
                                      wonLostCount[1]?.dealWon}
                                  </Link>
                                </td>
                                <td data-label="Lead Score">
                                  <a
                                    class="text-current"
                                    // href="tel:202-555-0152"
                                  >
                                    {Array.isArray(wonLostCount) &&
                                      wonLostCount.length &&
                                      wonLostCount[1]?.percentage}
                                  </a>
                                </td>
                                <td data-label="Lead Score">
                                  <a
                                    class="text-current"
                                    // href="tel:202-555-0152"
                                  >
                                    {Array.isArray(wonLostCount) &&
                                      wonLostCount.length &&
                                      wonLostCount[1]?.forecastedSales}
                                  </a>
                                </td>
                              </tr>
                              <tr>
                                <td data-label="Email">
                                  <span>Deals Lost</span>
                                </td>
                                <td data-label="Phone">
                                  <Link
                                    class="text-current"
                                    to="/leads/Lost"
                                    //href="mailto:robert.fox@example.com"
                                  >
                                    {Array.isArray(wonLostCount) &&
                                      wonLostCount.length &&
                                      wonLostCount[2]?.dealLost}
                                  </Link>
                                </td>
                                <td data-label="Lead Score">
                                  <a
                                    class="text-current"
                                    // href="tel:202-555-0152"
                                  >
                                    {Array.isArray(wonLostCount) &&
                                      wonLostCount.length &&
                                      wonLostCount[2]?.percentage}
                                  </a>
                                </td>
                                <td data-label="Lead Score">
                                  <a
                                    class="text-current"
                                    // href="tel:202-555-0152"
                                  >
                                    {Array.isArray(wonLostCount) &&
                                      wonLostCount.length &&
                                      wonLostCount[2]?.forecastedSales}
                                  </a>
                                </td>
                              </tr>
                              <tr>
                                <td data-label="Email">
                                  <span>Total Deals</span>
                                </td>
                                <td data-label="Phone">
                                  <Link
                                    to="/leads/Open"
                                    class="text-current"
                                    //href="mailto:robert.fox@example.com"
                                  >
                                    {Array.isArray(wonLostCount) &&
                                      wonLostCount.length &&
                                      wonLostCount[3]?.totalDeal}
                                  </Link>
                                </td>
                                <td data-label="Lead Score">
                                  <a
                                    class="text-current"
                                    // href="tel:202-555-0152"
                                  >
                                    {Array.isArray(wonLostCount) &&
                                      wonLostCount.length &&
                                      wonLostCount[3]?.percentage}
                                  </a>
                                </td>
                                <td data-label="Lead Score">
                                  <a
                                    class="text-current"
                                    // href="tel:202-555-0152"
                                  >
                                    {Array.isArray(wonLostCount) &&
                                      wonLostCount.length &&
                                      wonLostCount[3]?.forecastedSales}
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div
                          className="mt-2"
                          style={{ display: "flex", justifyContent: "end" }}
                        >
                          <ExportButton
                            reportUrl={`${apiUrl}/pipeLineReport/wonLostCountsExcel`}
                            filterState={filterData}
                            fileName="OpenLeads_Jan.csv"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="card custom-card">
                      <div className="card-body">
                        <h5 style={{ textDecoration: "underline" }}>
                          Shipment Potential (Sum of Total Potential)
                        </h5>

                        <div
                          class="table-responsive"
                          style={{ overflowY: "auto", height: "410px" }}
                        >
                          <table class="table table-hover table-nowrap">
                            <thead class="table-light">
                              <tr>
                                <th scope="col">Region / Product Line</th>
                                <th scope="col">Lead Count</th>
                                {/* <th scope="col">Potential (₹)</th> */}
                                <th scope="col">Percentage</th>
                                <th scope="col">forecasted Sales</th>
                              </tr>
                            </thead>
                            <tbody>
                              {shipmentPotentialCount?.map((item, index) => (
                                <tr key={index}>
                                  <td data-label="Email">
                                    <span>{item.state}</span>
                                  </td>
                                  <td data-label="Phone">
                                    <a
                                      class="text-current"
                                      //href="mailto:robert.fox@example.com"
                                    >
                                      {item.count}
                                    </a>
                                  </td>
                                  <td data-label="Email">
                                    <span>{item.percentage}</span>
                                  </td>
                                  <td data-label="Email">
                                    <span>{item.forecastedSales}</span>
                                  </td>

                                  {/* <td data-label="Phone">
                                    <a
                                      class="text-current"
                                      //href="mailto:robert.fox@example.com"
                                    >
                                      {"Not come from Api"}
                                    </a>
                                  </td> */}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        <div
                          className="mt-2"
                          style={{ display: "flex", justifyContent: "end" }}
                        >
                          <ExportButton
                            reportUrl={`${apiUrl}/pipeLineReport/shipmentPotentialCountExcel`}
                            filterState={filterData}
                            fileName="OpenLeads_Jan.csv"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card custom-card">
                      <div className="card-body">
                        <h5 style={{ textDecoration: "underline" }}>
                          Lead By Lead Stage
                        </h5>
                        <div class="table-responsive">
                          <table class="table table-hover table-nowrap">
                            <thead class="table-light">
                              <tr>
                                <th scope="col">Lead Stage</th>
                                <th scope="col">Lead Count</th>
                                {/* <th scope="col">Potaintial(₹)</th> */}
                                <th scope="col">Percentage</th>
                                <th scope="col">Forecasted Sales</th>
                              </tr>
                            </thead>
                            <tbody>
                              {stageCount?.map((item, index) => (
                                <tr key={index}>
                                  <td data-label="Email">
                                    <span>{item.status}</span>
                                  </td>
                                  <td data-label="Phone">
                                    <Link
                                      class="text-current"
                                      to={"/leads/Open"}
                                      state={{
                                        stage: item.status,
                                      }}
                                      //href="mailto:robert.fox@example.com"
                                    >
                                      {item.count}
                                    </Link>
                                  </td>
                                  <td data-label="Email">
                                    <span>{item.percentage}</span>
                                  </td>
                                  <td data-label="Email">
                                    <span>{item.forecastedSales}</span>
                                  </td>
                                  {/* <td data-label="Email">
                                    <span>{"Not come from Api"}</span>
                                  </td> */}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        <div
                          className="mt-2"
                          style={{ display: "flex", justifyContent: "end" }}
                        >
                          <ExportButton
                            reportUrl={`${apiUrl}/pipeLineReport/stageCountExcel`}
                            filterState={filterData}
                            fileName="OpenLeads_Jan.csv"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PipelineReport;
